var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGryvnya = function SvgGryvnya(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 260 260",
    width: 25,
    height: 30,
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    d: "m111.1 17.1c14.5-0.2 32.9 4.3 32.9 8 0 0.6 0.4 0.8 0.9 0.5 1.1-0.7 7.7 4.3 7.3 5.5-0.1 0.6 0.2 0.8 0.7 0.5 1.3-0.8 11.2 10.4 13.9 15.7 1.2 2.4 2.3 5.4 2.4 6.8 0.2 1.3 0.6 2.6 1 2.9 2.5 1.9 2.8 23 0.5 29.6l-1.5 4 4.8-0.4c14.1-1.2 23.2 9.3 18.9 21.7-0.9 2.5-1.4 2.9-2.5 2.1-0.8-0.8-1.9-0.8-3-0.2-1.5 0.8-1.5 0.9 0 1.5 1 0.4 1.5 0.3 1.1-0.3-0.3-0.6-0.1-1 0.5-1 0.6 0 1 0.8 0.8 1.7-0.2 1-1.1 1.7-2.1 1.7-0.9-0.1-1.4 0.2-1.1 0.7 1.3 2.1-5.8 3-21.8 2.7-9.3-0.2-16.4-0.2-15.8 0 0.5 0.2 0.4 1-0.5 1.8-0.8 0.8-3 3.4-5 5.9-2.1 2.4-4.2 4.3-4.8 4.2-0.7-0.1-1.1 0.4-0.9 1.1 0.1 0.7-1.4 3.3-3.4 5.8-2.8 3.4-4 4.2-4.7 3.2-0.6-1-0.8-0.9-0.4 0.4 0.3 0.9-0.2 2.5-1.1 3.6-0.9 1.1-4.1 4.9-7.1 8.6-3 3.6-5.8 6.3-6.3 6-0.4-0.3-0.5-1-0.2-1.6 0.4-0.7 0.2-0.8-0.5-0.4-0.9 0.6-0.9 1.1 0 2.2 0.8 1 0.6 2-1.3 4.3-1.2 1.7-2.9 2.8-3.6 2.6-0.7-0.3-1 0-0.7 0.6 0.9 1.3-1.4 4.1-2.8 3.2-0.5-0.3-0.7-0.1-0.4 0.4 0.4 0.6-0.3 3.2-1.4 5.8-2.9 6.6-2.7 11.5 0.7 19 2.6 5.4 6.8 9.1 13.9 12.4 5.7 2.6 6.5 2.7 16.5 2.1 9.7-0.7 17.2-2.7 19.1-5.3 0.3-0.4 1.4-0.5 2.5-0.1 1.2 0.4 1.5 0.3 0.7-0.3-0.9-0.6-0.4-1.7 1.7-4 3.6-3.9 6.5-4.9 8.7-3.1 0.9 0.7 1.4 0.8 1 0.2-1.3-2.1 2.4-2.4 6.6-0.6 4.7 2.1 7.2 4.6 6.2 6.2-0.4 0.6-0.1 0.9 0.6 0.8 1.9-0.4 3.4 7.5 2.2 11.5-0.5 1.7-1.5 3.1-2.1 2.9-0.7-0.1-1.1 0.1-1.1 0.5 0.1 0.5 0.1 1.3 0 2-0.1 1.7-13 11.9-14.4 11.5-0.6-0.2-1.6 0.3-2.2 1-4.7 6-30.3 9.7-46.7 6.8-7-1.3-20.8-7.2-20.8-9 0-0.6-0.4-0.9-0.8-0.6-1.1 0.7-11.4-8.4-14.4-12.6-1.3-1.9-1.6-2.8-0.7-2.4 0.7 0.4 0.3-0.1-1-1.2-1.5-1.2-2.1-2.4-1.6-3.2 0.5-0.8 0.4-1.1-0.2-0.7-1.2 0.8-5.8-9.7-4.9-11.2 0.3-0.5 0.1-1.1-0.5-1.3-2.6-0.9-2.2-20.8 0.6-27.9 0.5-1.4-0.5-1.7-6.3-2.1-8.3-0.6-12.7-2.9-15.3-8-3.6-7-1.8-15.3 4.4-19.9 3-2.3 4-2.4 20.7-2.7l17.5-0.4 3.3-3.9c1.9-2.1 3.8-3.6 4.4-3.3 0.7 0.4 0.8 0.2 0.4-0.5-1-1.5 1.3-4.3 2.8-3.4 0.6 0.3 0.8 0.3 0.4-0.2-0.4-0.4 0.1-2.2 1.1-3.9l2-3.1-14.7 0.3c-15.4 0.3-19.7-0.1-18.6-2 0.4-0.7 0.3-0.8-0.5-0.4-1.2 0.8-7.1-2.9-7.1-4.5 0-0.6 0.4-0.7 1-0.4 0.6 0.3 0.7-0.1 0.4-0.9-0.3-0.9-1-1.4-1.4-1.1-1.7 1.1-2.7-6.4-1.4-10 0.6-1.3 0.9-1.4 1.6-0.3 0.6 0.9 0.7 0.5 0.3-1-0.7-2.4 1.7-6.2 3.8-6.2 0.5 0 1.6-0.8 2.3-1.8 1.1-1.5 3.9-1.7 27.5-2 20.8-0.3 26.4-0.1 27 1 0.5 0.8 0.9 0.9 0.9 0.2 0-0.6 1.2-1.2 2.6-1.2 1.5 0 3.1-0.7 3.6-1.5 0.4-0.9 1.4-2.2 2.1-2.9 0.8-0.7 1.4-1.5 1.4-1.8 0-0.3 0.6-2.9 1.3-5.9 1-4.4 1-6.4-0.1-11-0.7-3.1-1.2-5.9-1.1-6.4 0.1-0.4-0.3-0.7-0.9-0.7-0.6 0-0.8-0.7-0.5-1.6 0.3-0.8 0.2-1.3-0.3-1-0.5 0.3-2.4-0.9-4.3-2.7-2-1.8-5.9-4.1-8.8-5-7.4-2.4-20-2.2-27 0.4-3 1.2-6.5 2.2-7.7 2.2-1.1 0.1-1.9 0.5-1.7 0.8 0.6 1-4 6.1-7.8 8.5-2.7 1.7-5 2.4-8.3 2.2-2.4 0-4.2-0.5-3.9-0.9 0.3-0.5-0.1-0.6-0.8-0.4-1.5 0.6-6.9-3.9-8.6-7.1-1.8-3.3-1.2-10.5 1.1-14.4 2.3-3.8 7.7-9.7 7.7-8.4 0 0.5 0.7-0.1 1.5-1.3 2.9-4.2 18.2-11.6 26.5-12.9 1.9-0.3 3.6-0.7 3.8-0.9 0.2-0.2 5.3-0.4 11.3-0.4zm33.8 11.1c-0.5 1.8-0.6 3.8-0.1 3.4 0.3-0.4 0.7-1.3 0.8-2.1 0.2-1.2-0.4-2.2-0.7-1.3zm-73.1 3.3c-0.3-0.3-0.9 0.2-1.2 1.2-0.6 1.4-0.5 1.5 0.5 0.6 0.7-0.7 1-1.5 0.7-1.8zm82.2 4.4c0 0.6 0.4 1.3 1 1.6 0.6 0.3 0.7-0.1 0.4-0.9-0.7-1.8-1.4-2.1-1.4-0.7zm7.8 6.6c-0.3-0.3-0.9 0.2-1.2 1.2-0.6 1.4-0.5 1.5 0.5 0.6 0.7-0.7 1-1.5 0.7-1.8zm-98.3 15.4c-0.3 0.5-0.2 1.2 0.3 1.5 0.5 0.3 0.9-0.1 0.9-0.9 0-1.7-0.3-1.9-1.2-0.6zm80.3-0.4c-0.3-0.3-0.9 0.2-1.2 1.2-0.6 1.4-0.5 1.5 0.5 0.6 0.7-0.7 1-1.5 0.7-1.8zm-33.4 65.9c-1.4-1.8-1.5-1.8-0.4 0.4 0.6 1.2 0.8 2.8 0.4 3.4-0.4 0.7-0.3 0.8 0.4 0.4 0.7-0.4 1.2-1.1 1.2-1.5 0-0.4-0.7-1.6-1.6-2.7zm49.6 110.6c-0.9 0.6-1 1-0.3 1 0.6 0 1.5-0.5 1.8-1 0.8-1.2 0.4-1.2-1.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 1",
    d: "m118 134c-68.5-16.5 158.8-41.8-12-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 2",
    d: "m116 141h35v17h-35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 3",
    d: "m140 151v2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 4",
    d: "m104 153h40v16h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 5",
    d: "m114 140h26v13h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 6",
    d: "m85 161h58v9h-58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 7",
    d: "m109 124h6v11h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 8",
    d: "m142 53h6v8h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 9",
    d: "m159 42h3v13h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 10",
    d: "m152 34h4v9h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 11",
    d: "m141 28h6v7h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 12",
    d: "m71 31h5v8h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 13",
    d: "m70 32h3v11h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 14",
    d: "m64 54h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 15",
    d: "m63 54h3v5h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 16",
    d: "m68 108h6v5h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 17",
    d: "m68 99h3v11h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 18",
    d: "m126 91h6v10h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 19",
    d: "m179 109h10v7h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 20",
    d: "m185 106h6v9h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 21",
    d: "m160 155h13v11h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 22",
    d: "m139 166h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 23",
    d: "m153 228h9v7h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 24",
    d: "m166 198h5v7h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 25",
    d: "m155 216h10v8h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 26",
    d: "m156 206h3v6h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 27",
    d: "m176 218h6v3h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 28",
    d: "m178 205h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 29",
    d: "m96 228h5v5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 30",
    d: "m75 117h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 31",
    d: "m138 54h5v4h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 32",
    d: "m142 25h3v4h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u0444\\u043E\\u0440\\u043C\\u0430 33",
    d: "m149 31h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    d: "m154.5 139.2c8.2 0 11.6 0.3 13.4 1.5 1.8 1.1 2.2 1.2 1.6 0.2-0.5-0.8 0.7-0.1 2.4 1.6 6.2 5.7 7.8 12.9 3.9 17.4-1.6 1.8-1.7 2.1-0.4 1.1 1.8-1.4 1.8-1.4 0.9 0.5-1.8 3.4-6.1 6.8-7.4 6-0.7-0.5-1-0.4-0.6 0.2 1 1.6-2.9 2.3-14.1 2.3-11.6 0-15.1-1.1-19.7-5.9-2.6-2.9-3-3.9-3-9.2 0-3.3 0.5-6.3 1-6.7 0.6-0.4 1.1-1.4 1.3-2.2 0.4-1.9 5-5.8 7.7-6.3 1.1-0.3 7-0.5 13-0.5zm15.4 24.5c-1.3 1.6-1.2 1.7 0.4 0.4 0.9-0.7 1.7-1.5 1.7-1.7 0-0.8-0.8-0.3-2.1 1.3z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGryvnya, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gryvnya.51a34a73.svg";
export { ForwardRef as ReactComponent };